import { Component } from 'react';

import { Button } from '@mui/material';

export default class ProjectImage extends Component {
  constructor(props) {
    super(props);

    const item = props.item;
    const title = item.title;
    const link = item.link;
    const img = item.src;
    const gif = item.gif;
    const src = img;
    this.state = {
      title,
      link,
      img,
      gif,
      src
    }
  }

  onMouseEnter() {
    if (this.state.gif !== undefined) {
      this.setState({src: this.state.gif});
    }
  }
  onMouseOut() {
    this.setState({src: this.state.img});
  }

  render() {
    const {
      title,
      link,
      src
    } = this.state;

    return (
      <Button className='transparent' href={link} onMouseEnter={() => {this.onMouseEnter()}} onMouseOut={() => {this.onMouseOut()}}>
        <img className='project-image' src={src} alt={title} loading='lazy' />
      </Button>
    );
  }
}
